import type { ComponentPropsWithoutRef } from 'react';
import styled from 'styled-components';

const StyledButton = styled.button`
  display: inline-flex;
  min-height: 44px;
  align-items: center;
  justify-content: center;
  gap: 9px;
  padding: 9px 16px;
  border: 2px solid #4c2c92;
  border-radius: 3px;
  box-shadow: 0 3px 0 #2f1b59;
  color: #ffffff;
  background: #4c2c92;
  font: inherit;
  font-weight: 700;
  line-height: 1.2;
  cursor: pointer;

  &:hover {
    border-color: #3a216f;
    background: #3a216f;
  }

  &:active {
    transform: translateY(2px);
    box-shadow: 0 1px 0 #2f1b59;
  }

  &:focus {
    outline: 3px solid #ffdd00;
    outline-offset: 0;
    border-color: #0b0c0c;
    box-shadow: 0 3px 0 #0b0c0c;
    color: #0b0c0c;
    background: #ffdd00;
  }

  svg {
    width: 18px;
    height: 18px;
    fill: currentColor;
  }
`;

const SwitchIcon = () => (
  <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24">
    <path d="M7.4 5.3 3.7 9H17a1 1 0 1 1 0 2H3.7l3.7 3.7L6 16.1.6 10.7a1 1 0 0 1 0-1.4L6 3.9l1.4 1.4ZM16.6 8.9 18 7.5l5.4 5.4a1 1 0 0 1 0 1.4L18 19.7l-1.4-1.4 3.7-3.7H7a1 1 0 1 1 0-2h13.3l-3.7-3.7Z" />
  </svg>
);

type Props = Omit<ComponentPropsWithoutRef<'button'>, 'children' | 'type'>;

export default function InputMethodButton(props: Props) {
  return (
    <StyledButton {...props} type="button">
      <SwitchIcon />
      <span>Change input method</span>
    </StyledButton>
  );
}
